import { defaultValueSelectors, localStorage, session } from 'lib_ui-services';
import { useEffect, useState, useCallback } from 'react';

/**
 * Custom hook that returns the dark mode preference state.
 * Returns false if there is no os preference and no previous stored preference.
 */
export default () => {
    const osPreference = defaultValueSelectors.getDarkModePreference();
    const [ready, setReady] = useState(false);
    const [darkMode, setDarkMode] = useState(osPreference);
    const setDarkModePreference = useCallback(
        async darkMode => {
            const profile = await session.cache.getProfile(false);
            if (profile) {
                const { userId } = profile;
                const storedPreferences = await localStorage.getKey('darkModePreferences', '', {}, false);
                storedPreferences[userId] = darkMode;
                await localStorage.setKey('darkModePreferences', storedPreferences, '', false);
            }
            setDarkMode(darkMode);
        },
        [setDarkMode]
    );
    useEffect(() => {
        const doAsync = async () => {
            const profile = await session.cache.getProfile(false);

            if (profile) {
                const { userId } = profile;
                const storedPreferences = await localStorage.getKey('darkModePreferences', '', undefined, false);
                const storedPreference = storedPreferences?.[userId];
                if (storedPreference != null) {
                    setDarkMode(storedPreference);
                }
            }
            setReady(true);
        };
        doAsync();
    }, []);
    return { darkMode, setDarkMode: setDarkModePreference, ready };
};